export const networks_ENUM = {
  MUMBAI: 80001,
  POLYGON: 137,
};

export const deployed_address = {
  Manager: '0xf00eAbb380752fed6414f3C12e3D8F976C7D024d',
  Beacon: '0xDcc7133abBA15B8f4Bf155A372C17744E0941f28',
  Router: '0x1C6D20042bfc8474051Aba9FB4Ff85880089A669',
};

export const deployed_address_polygon = {
  Manager: '0xDA6F4387C344f1312439E05E9f9580882abA6958',
  Beacon: '0x083842b3F6739948D26C152C137929E0D3a906b9',
  Router: '0xB9Acf5287881160e8CE66b53b507F6350d7a7b1B',
};

export const BASE_URL = {
  subgraph_mainnet:
    'https://api.thegraph.com/subgraphs/name/eth-jashan/rep3-matic',
  subgraph: 'https://api.thegraph.com/subgraphs/name/eth-jashan/rep3-mumbai',
};

export const SIGNING_DOMAIN_NAME = 'REP3Signer';
export const SIGNING_DOMAIN_VERSION = '0.0.1';
